import { createContext } from "react";
import { WebViewContextProps, WebViewProviderProps } from "./types";

const WebViewContext = createContext<WebViewContextProps>({
  isWebView: false,
});

export const WebViewProvider = ({ children }: WebViewProviderProps) => {
  const params = new URLSearchParams(window.location.search);
  const isWebView = params.has("webview");

  return (
    <WebViewContext.Provider value={{ isWebView }}>
      {children}
    </WebViewContext.Provider>
  );
};

export default WebViewContext;
